import { useState, useEffect } from 'react';
import { apiRequest } from '../config/api';
import useAuth from './useAuth';

const useInstances = () => {
  const { user } = useAuth();
  const [instances, setInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInstances = async () => {
    if (!user?.id) {
      setInstances([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const data = await apiRequest(`/instances/user/${user.id}`);

      if (data.success && data.instances) {
        // Normaliza instanceName (backend pode retornar instancename minúsculo)
        const normalizedInstances = data.instances.map(instance => ({
          ...instance,
          instanceName: instance.instanceName || instance.instancename
        }));
        setInstances(normalizedInstances);
      } else {
        setInstances([]);
      }
    } catch (err) {
      console.error('Erro ao buscar instâncias:', err);
      setError(err.message);
      setInstances([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstances();
  }, [user?.id]);

  const getActiveConnections = () => {
    return instances.filter(instance => 
      instance.status === 'connected' || 
      instance.status === 'open' ||
      instance.connected === true
    ).length;
  };

  const getTotalInstances = () => {
    return instances.length;
  };

  return {
    instances,
    loading,
    error,
    activeConnections: getActiveConnections(),
    totalInstances: getTotalInstances(),
    refetch: fetchInstances
  };
};

export default useInstances;
